// extracted by mini-css-extract-plugin
export default {"container":"wo-z","brandName":"xo-z","productName":"yo-z","productNamePdpEnhancements":"zo-z","breakLongProductName":"Ao-z"};